/**
 * stripName — 종목명 표시용 접미사 정규화 (사용자 결정 2026-06-13 C5).
 *
 * 거래소 raw 종목명에 붙는 주식 종류/클래스/ADR 접미사만 제거하고
 * 법인격(Inc., Corp. 등)은 유지합니다. 백엔드가 이미 정규화했어도 멱등(무해)입니다.
 *
 * 예: "Tesla, Inc. Common Stock"            → "Tesla, Inc."
 *     "Apple Inc. Common Stock"             → "Apple Inc."
 *     "AST SpaceMobile, Inc. Class A Common Stock" → "AST SpaceMobile, Inc."
 *     "Taiwan Semiconductor ... American Depositary Shares" → "Taiwan Semiconductor ..."
 *
 * 법인격까지 더 짧게 줄이려면 lib/clean-company-name.ts 의 cleanCompanyName 을 쓰세요.
 * 이 유틸은 "원래 종목명을 거의 보존하되 거래소 접미사만 떼는" 가벼운 표시용입니다.
 */
export function stripName(name: string | null | undefined): string {
  if (!name || typeof name !== "string") return "";
  const stripped = name
    .replace(/\s*-?\s*(Common Stock\b.*|Class [A-Z].*|Ordinary Shares.*|American Depositary.*)$/i, "")
    .replace(/\s+/g, " ")
    .trim();
  return stripped || name.trim();
}
